import React, { useEffect } from 'react';
import { Container } from "../../../components/Container/Container";
import { DialogActions } from "../../../components/Dialog/DialogActions";
import { DialogButton } from "../../../components/Dialog/DialogButton";
import { useDeclarativeLoading } from "../../../hooks/useLoading";
import { useTranslation } from "../../../hooks/useTranslation";
import { useUseCase } from "../../../hooks/useUseCase";
import { makeStyles } from "../../../styles/index";
import { SelectedWorks } from "../components/SelectedWorks";
import { TemplateContent } from "./components/TemplateContent";
import { ChangeGradeUseCase } from "./usecase/ChangeGradeUseCase";
import { ChangeSubjectUseCase } from "./usecase/ChangeSubjectUseCase";
import { InitializeUseCase } from "./usecase/InitializeUseCase";
import { LoadWorkTemplateGroupsUseCase } from "./usecase/LoadWorkTemplateGroupsUseCase";
import { SelectTemplateUseCase } from "./usecase/SelectTemplateUseCase";
import { UnselectTemplateUseCase } from "./usecase/UnselectTemplateUseCase";
import { initialWorkTemplateTabState } from "./WorkTemplateTabState";
var useStyles = makeStyles(function () { return ({
    container: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        overflow: 'hidden',
        maxWidth: 'none',
        padding: 0,
    },
    actions: {
        position: 'relative',
    },
}); }, { name: 'SnWorkTemplateTab' });
/**
 * 「テンプレート」タブ
 */
export var WorkTemplateTab = function (_a) {
    var _b;
    var maxSelectableWorkNumber = _a.maxSelectableWorkNumber, selectionGrades = _a.selectionGrades, selectionSubjects = _a.selectionSubjects, templateGroups = _a.templateGroups, onChangeGrade = _a.onChangeGrade, onSelect = _a.onSelect, onCancel = _a.onCancel;
    var classes = useStyles();
    var t = useTranslation().t;
    var _c = useUseCase(initialWorkTemplateTabState), state = _c.state, usecase = _c.usecase;
    var handleChangeGrade = function (grade) {
        usecase(new ChangeGradeUseCase()).execute({ grade: grade, subject: state.subject });
        onChangeGrade(grade);
    };
    var handleChangeSubject = function (subject) {
        usecase(new ChangeSubjectUseCase()).execute({ subject: subject, grade: state.grade });
    };
    var handleSelectTemplate = function (templateIds, templateGroupId) {
        if (state.currentTemplateGroups != null) {
            usecase(new SelectTemplateUseCase()).execute({
                templateGroups: state.currentTemplateGroups,
                templateGroupId: templateGroupId,
                templateIds: templateIds,
            });
        }
    };
    var handleUnselectTemplate = function (templateIds) {
        if (state.currentTemplateGroups != null) {
            usecase(new UnselectTemplateUseCase()).execute({
                templateGroups: state.currentTemplateGroups,
                templateIds: templateIds,
            });
        }
    };
    var handleSelect = function () {
        onSelect(state.templateGroups);
    };
    useEffect(function () {
        usecase(new InitializeUseCase()).execute({ selectionGrades: selectionGrades, selectionSubjects: selectionSubjects, templateGroups: templateGroups, onChangeGrade: onChangeGrade });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (state.initialized && state.currentTemplateGroups == null) {
            usecase(new LoadWorkTemplateGroupsUseCase()).execute({ courseIds: state.selectedCourseIds });
        }
    }, [
        state.currentTemplateGroups,
        state.drillTypes,
        state.grade,
        state.initialized,
        state.selectedCourseIds,
        usecase,
    ]);
    useEffect(function () {
        // 教科リスト変更前に選択されていた教科が変更後教科リストにない場合は、
        // 変更後の教科リストの先頭要素を新しい選択教科とする。
        if (selectionSubjects.find(function (_a) {
            var id = _a.id;
            return id === state.subject;
        }) == null) {
            usecase(new ChangeSubjectUseCase()).execute({ subject: selectionSubjects[0].id, grade: state.grade });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectionSubjects]);
    useDeclarativeLoading('loading', state.isLoading);
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { className: classes.container },
            React.createElement(TemplateContent, { grade: state.grade, hasError: state.hasError, isLoading: state.isLoading, remainingCount: maxSelectableWorkNumber - state.selectedCount, selectionGrades: selectionGrades, selectionSubjects: selectionSubjects, subject: state.subject, workTemplateGroups: (_b = state.currentTemplateGroups) !== null && _b !== void 0 ? _b : [], onChangeGrade: handleChangeGrade, onChangeSubject: handleChangeSubject, onSelectTemplate: handleSelectTemplate, onUnselectTemplate: handleUnselectTemplate })),
        React.createElement(DialogActions, { className: classes.actions },
            React.createElement(SelectedWorks, { maxCount: maxSelectableWorkNumber, selectedCount: state.selectedCount }),
            React.createElement(DialogButton, { onClick: onCancel }, t('キャンセル')),
            React.createElement(DialogButton, { fill: true, onClick: handleSelect, disabled: state.selectedCount === 0 }, t('選ぶ')))));
};
